export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11419.624094f0.jpg";